document.addEventListener('DOMContentLoaded', function () {
    const buyBox = document.getElementById('CustomBuyBox');
    if (!buyBox) return;

    const toggles = buyBox.querySelectorAll('.custom-buybox__toggle-option');
    const optionsContainer = document.getElementById('CustomBuyBoxOptions');
    const options = buyBox.querySelectorAll('.custom-buybox__option');
    const subtext = document.getElementById('CustomBuyBoxSubtext');

    const dataElement = document.getElementById('CustomBuyBoxData');
    if (!dataElement) return;

    const variantsData = JSON.parse(dataElement.textContent);

    function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
    }

    let currentType = 'subscription'; // 'subscription' or 'onetime'

    function updatePricingUI() {
        options.forEach((option) => {
            const variantId = parseInt(option.getAttribute('data-variant-id'));
            const data = variantsData.find(v => v.id === variantId);
            if (!data) return;

            const newPriceEl = option.querySelector('.custom-buybox__price-new');
            const oldPriceEl = option.querySelector('.custom-buybox__price-old');
            const subtitleEl = option.querySelector('.custom-buybox__option-subtitle');
            const badgeEl = option.querySelector('.custom-buybox__badge');

            let priceToUse = currentType === 'subscription' ? data.sub_price : data.price;
            const optIndex = parseInt(option.getAttribute('data-index'));
            let oldPriceToUse = data.compare_at_price > data.price ? data.compare_at_price : (currentType === 'subscription' ? data.price : null);
            // Hide strikethrough on 1-jar one-time (no savings to show)
            if (currentType === 'onetime' && optIndex === 1) oldPriceToUse = null;

            if (newPriceEl) newPriceEl.textContent = formatMoney(priceToUse);

            if (oldPriceEl) {
                if (oldPriceToUse && oldPriceToUse > priceToUse) {
                    oldPriceEl.textContent = formatMoney(oldPriceToUse);
                    oldPriceEl.style.display = 'block';
                } else {
                    oldPriceEl.style.display = 'none';
                }
            }

            let savedPercent = 0;
            const index = parseInt(option.getAttribute('data-index'));
            // Base reference: what it would cost to buy this many single jars at the 1-jar one-time price
            const singleJarPrice = variantsData[0].price;
            const referencePrice = singleJarPrice * index;

            if (referencePrice > priceToUse) {
                savedPercent = Math.round(((referencePrice - priceToUse) / referencePrice) * 100);
            }

            if (badgeEl) {
                if (savedPercent > 0) {
                    badgeEl.textContent = `Save ${savedPercent}%`;
                    badgeEl.style.display = 'inline-block';
                } else {
                    badgeEl.style.display = 'none';
                }
            }

            if (subtitleEl) {
                const index = parseInt(option.getAttribute('data-index'));
                const chews = index * 60; // 60 chews per jar/tub
                const perChew = (priceToUse / 100 / chews).toFixed(2);
                subtitleEl.textContent = `${chews} Chews / $${perChew} per chew`;
            }

            const nameEl = option.querySelector('.custom-buybox__option-name');
            if (nameEl) {
                // Always show the exact Shopify variant title
                nameEl.textContent = data.title;
            }

            const features = option.querySelector('.custom-buybox__features');
            if (features) {
                if (currentType === 'subscription' && option.classList.contains('active')) {
                    features.style.display = 'block';
                } else {
                    features.style.display = 'none';
                }
            }
        });

        if (currentType === 'subscription') {
            subtext.innerHTML = 'As a subscriber you are getting our <strong>lowest price</strong>';
        } else {
            const activeOpt = document.querySelector('.custom-buybox__option.active');
            let saveText = '$12.48';
            if (activeOpt) {
                const variantId = parseInt(activeOpt.getAttribute('data-variant-id'));
                const data = variantsData.find(v => v.id === variantId);
                if (data) {
                    const diff = data.price - data.sub_price;
                    saveText = formatMoney(diff);
                }
            }
            subtext.innerHTML = `Switch to a subscription to <strong>save an extra ${saveText}</strong>`;
        }
    }

    function syncAppstleWidget(isSub) {
        const appstleSubRadio = document.querySelector('.appstle_subscribe_widget input[value="1"], .appstle_subscribe_widget input[name="purchase_option"][value="subscribe"]');
        const appstleOneTimeRadio = document.querySelector('.appstle_subscribe_widget input[value="0"], .appstle_subscribe_widget input[name="purchase_option"][value="onetime"]');

        if (isSub && appstleSubRadio && !appstleSubRadio.checked) {
            appstleSubRadio.click();
        } else if (!isSub && appstleOneTimeRadio && !appstleOneTimeRadio.checked) {
            appstleOneTimeRadio.click();
        }
    }

    function syncVariant(variantId) {
        const data = variantsData.find(v => v.id === variantId);

        // Strategy 1: Find a named radio in Dawn 
        if (data && data.title) {
            const radio = document.querySelector(`variant-radios input[type="radio"][value="${data.title}"]`);
            if (radio && !radio.checked) {
                radio.click();
            }
        }

        // Strategy 2: Directly assign hidden ID input the forms use
        const mainForms = document.querySelectorAll('form[action*="/cart/add"]');
        mainForms.forEach(form => {
            // Sync Variant ID
            let idInput = form.querySelector('input[name="id"]');
            if (idInput) {
                idInput.value = variantId;
                idInput.dispatchEvent(new Event('change', { bubbles: true }));
            }

            // Sync Selling Plan ID (Crucial for adding as a subscription to cart)
            let planInput = form.querySelector('input[name="selling_plan"]');
            if (!planInput) {
                // If the form doesn't natively have a selling_plan input, we must inject it
                planInput = document.createElement('input');
                planInput.type = 'hidden';
                planInput.name = 'selling_plan';
                form.appendChild(planInput);
            }

            if (currentType === 'subscription' && data.selling_plan_id) {
                let finalSellingPlanId = data.selling_plan_id;
                const activeOpt = document.querySelector(`.custom-buybox__option[data-variant-id="${variantId}"]`);
                if (activeOpt) {
                    const sel = activeOpt.querySelector('.custom-buybox__frequency-select');
                    if (sel && sel.value) {
                        finalSellingPlanId = sel.value;
                    }
                }
                planInput.value = finalSellingPlanId;
            } else {
                planInput.value = ''; // Empty means one-time purchase
            }
        });

        // Strategy 3: Sync URL
        if (window.history && window.history.replaceState) {
            const url = new URL(window.location);
            url.searchParams.set('variant', variantId);
            window.history.replaceState({}, '', url);
        }

        // Strategy 4: Update Add to Cart Button Content
        const submitBtns = document.querySelectorAll('button[name="add"].product-form__submit');
        submitBtns.forEach(btn => {
            const span = btn.querySelector('span');
            if (span && !btn.hasAttribute('disabled')) {
                let priceToUse = currentType === 'subscription' ? data.sub_price : data.price;
                let oldPriceToUse = data.compare_at_price > data.price ? data.compare_at_price : (currentType === 'subscription' ? data.price : null);

                let formatCompare = '';
                if (oldPriceToUse && oldPriceToUse > priceToUse) {
                    formatCompare = `<span class="custom-cart-btn-compare">${formatMoney(oldPriceToUse)}</span> `;
                }

                span.innerHTML = `${formatCompare}<span class="custom-cart-btn-price">${formatMoney(priceToUse)}</span> - Add to cart`;
            }
        });
    }

    toggles.forEach(toggle => {
        toggle.addEventListener('click', function () {
            toggles.forEach(t => t.classList.remove('active'));
            this.classList.add('active');
            currentType = this.getAttribute('data-type');

            updatePricingUI();

            // Re-sync current active variant so the selling_plan input updates
            const activeOpt = document.querySelector('.custom-buybox__option.active');
            if (activeOpt) {
                const variantId = parseInt(activeOpt.getAttribute('data-variant-id'));
                syncVariant(variantId);
            }

            syncAppstleWidget(currentType === 'subscription');
        });
    });

    options.forEach(option => {
        option.addEventListener('click', function () {
            options.forEach(opt => {
                opt.classList.remove('active');
                const inp = opt.querySelector('input');
                if (inp) inp.checked = false;
                const feats = opt.querySelector('.custom-buybox__features');
                if (feats) feats.style.display = 'none';
            });

            this.classList.add('active');
            const inp = this.querySelector('input');
            if (inp) inp.checked = true;

            const variantId = parseInt(this.getAttribute('data-variant-id'));

            const feats = this.querySelector('.custom-buybox__features');
            if (currentType === 'subscription' && feats) {
                feats.style.display = 'block';
            }

            updatePricingUI();
            syncVariant(variantId);
        });
    });

    const selects = buyBox.querySelectorAll('.custom-buybox__frequency-select');
    selects.forEach(select => {
        select.addEventListener('change', function () {
            const activeOpt = document.querySelector('.custom-buybox__option.active');
            if (activeOpt) {
                const variantId = parseInt(activeOpt.getAttribute('data-variant-id'));
                syncVariant(variantId);
            }
        });
    });

    updatePricingUI();

    setTimeout(() => {
        syncAppstleWidget(currentType === 'subscription');
        const appstleWidget = document.querySelector('.appstle_subscribe_widget');
        if (appstleWidget) {
            appstleWidget.style.display = 'none';
        }

        const dawnQty = document.querySelector('quantity-input');
        if (dawnQty) {
            const qtyWrapper = dawnQty.closest('.product-form__input.product-form__quantity');
            if (qtyWrapper) qtyWrapper.style.display = 'none';
            else dawnQty.style.display = 'none';
        }

        const variantPicker = document.querySelector('variant-radios, variant-selects');
        if (variantPicker) {
            variantPicker.style.display = 'none';
        }

        const firstActive = document.querySelector('.custom-buybox__option.active');
        if (firstActive) {
            const variantId = parseInt(firstActive.getAttribute('data-variant-id'));
            syncVariant(variantId);
        }

        // Master override for "Delivery by" app block
        const buyBtnsWrapper = document.getElementById('custom-buy-buttons-wrapper');
        if (buyBtnsWrapper && buyBtnsWrapper.previousElementSibling) {
            const appBlock = buyBtnsWrapper.previousElementSibling;

            // Assign custom ID to lock it into our stylesheet
            appBlock.id = "custom-section-store-centered";

            // Inject nuclear CSS specifically for this block's shadow or isolated DOM
            const style = document.createElement('style');
            style.innerHTML = `
                #custom-section-store-centered {
                    display: flex !important;
                    justify-content: center !important;
                    width: 100% !important;
                }
                #custom-section-store-centered > div {
                    margin-left: auto !important;
                    margin-right: auto !important;
                    justify-content: center !important;
                    text-align: center !important;
                }
                #custom-section-store-centered * {
                    text-align: center !important;
                }
            `;
            document.head.appendChild(style);
        }

    }, 1000);

    // Cancel tooltip — mobile tap support
    document.querySelectorAll('.custom-buybox__cancel-trigger').forEach(trigger => {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const wrap = this.closest('.custom-buybox__cancel-tooltip-wrap');
            if (!wrap) return;

            // Close all other open tooltips first
            document.querySelectorAll('.custom-buybox__cancel-tooltip-wrap.tooltip-active').forEach(w => {
                if (w !== wrap) w.classList.remove('tooltip-active');
            });

            wrap.classList.toggle('tooltip-active');
        });
    });

    // Close tooltip when tapping anywhere else
    document.addEventListener('click', function (e) {
        if (!e.target.closest('.custom-buybox__cancel-tooltip-wrap')) {
            document.querySelectorAll('.custom-buybox__cancel-tooltip-wrap.tooltip-active').forEach(w => {
                w.classList.remove('tooltip-active');
            });
        }
    });
});
